import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import { cn } from '../../lib/utils';

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(() => {
    return localStorage.getItem('sidebar-collapsed') === 'true';
  });
  const location = useLocation();

  const isFullWidthPage = location.pathname === '/calendar';

  const handleCollapsedChange = (value: boolean) => {
    setCollapsed(value);
    localStorage.setItem('sidebar-collapsed', String(value));
  };

  return (
    <div className={cn(
      "min-h-screen bg-background",
      isFullWidthPage && "h-screen overflow-hidden"
    )}>
      <Header onMenuClick={() => setSidebarOpen(true)} />
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        collapsed={collapsed}
        onCollapsedChange={handleCollapsedChange}
      />

      <div
        className={cn(
          "h-full transition-all duration-300 ease-in-out",
          collapsed ? "lg:pl-[70px]" : "lg:pl-[280px]"
        )}
      >
        {isFullWidthPage ? (
          <main className="h-full p-3 pt-[72px] overflow-hidden">
            <Outlet />
          </main>
        ) : (
          <main className="pt-20 pb-8">
            <div className="mx-auto max-w-[1600px] px-4 sm:px-6 lg:px-8">
              <Outlet />
            </div>
          </main>
        )}
      </div>
    </div>
  );
}
